var render = function render(_c,_vm){return _c('a',_vm._b({class:['eyecatcher-image-wrapper', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id}},'a',_vm.data.attrs,false),[_vm._t("image"),_c('span',{staticClass:"eyecatcher-image"},[_c('span',{staticClass:"eyecatcher-image-border"},[_c('span',{staticClass:"eyecatcher-image-content"},[_vm._t("default")],2)])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }